module.exports = __webpack_public_path__ + "static/media/pres29.440b5bc2.png";